<p-table stripedRows #dataTable [value]="items" [(selection)]="selected" [scrollable]="true" scrollHeight="flex" dataKey="id"
    editMode="row" selectionMode="Multiple" (selectionChange)="SelectItem.next($event)">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
            <!-- status-->
            <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                <i class="pi pi-exclamation-circle" title="Status"></i>
            </th>
            <!-- Selection -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" class="select-cell">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <!-- Contractdesc -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Contractdesc">
                Contract
                <p-sortIcon field="Contractdesc" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="Contractdesc" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" [options]="contracts"
                            [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Chargenumber -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Chargenumber">
                Charge Number
                <p-sortIcon field="Chargenumber" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="Chargenumber" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                            [options]="chargeNumbers" [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Contracttype -->
            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Contracttype">
                Type
                <p-sortIcon field="Contracttype" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                <p-columnFilter field="Contracttype" matchMode="in" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body" [options]="types"
                            [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!--  ADDRESS GROUP -->
            <!-- ShowEIN -->
            <th pSortableColumn="ShowEIN" *ngIf="displayAddress">
                Taxpayer Id
                <p-sortIcon field="ShowEIN" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- remitTo -->
            <th *ngIf="displayAddress">
                Remit To
            </th>
            <!-- billTo -->
            <th *ngIf="displayAddress">
                Bill To
            </th>
            <!-- GENERAL INVOICE INFORMATION -->
            <!--  Invoiceviewoptionid -->
            <th pSortableColumn="Invoiceviewoptionid">
                Detail View
                <p-sortIcon field="Invoiceviewoptionid" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Invprefix -->
            <th pSortableColumn="Invprefix">
                Invoice Prefix
                <p-sortIcon field="Invprefix" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showindirectrates -->
            <th>
                Indirect Rates
            </th>
            <!-- Showfundingbalance -->
            <th pSortableColumn="Showfundingbalance">
                Funding Balance
                <p-sortIcon field="Showfundingbalance" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showcontractbalance -->
            <th pSortableColumn="Showcontractbalance">
                Contract Balance
                <p-sortIcon field="Showcontractbalance" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showcosttypesummary -->
            <th pSortableColumn="Showcosttypesummary">
                Cost Type Summary
                <p-sortIcon field="Showcosttypesummary" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showlaborrates -->
            <th pSortableColumn="Showlaborrates">
                Labor Rates
                <p-sortIcon field="Showlaborrates" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showburdens -->
            <th pSortableColumn="Showburdens">
                Burdens
                <p-sortIcon field="Showburdens" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showcurrentactivityonly -->
            <th pSortableColumn="Showcurrentactivityonly">
                Current Period Only
                <p-sortIcon field="Showcurrentactivityonly" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- Showcosttypesummaryburden -->
            <th pSortableColumn="Showcosttypesummaryburden">
                Cost Type Burden
                <p-sortIcon field="Showcosttypesummaryburden" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <!-- accountClass -->
            <th>
                Account Class
            </th>
            <!-- FOOTER GROUP -->
            <!-- signature -->
            <th *ngIf="displayFooter">
                Signature
            </th>
            <!-- disclaimer -->
            <th *ngIf="displayFooter">
                Disclaimer
            </th>
            <!-- payment terms -->
            <th *ngIf="displayFooter">
                Payment Terms
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex" let-rowData>
        <tr [pSelectableRow]="item" [pEditableRow]="item" data-id="row-{{ item.id }}" [ngClass]="{
                'ui-editing-row': edit && editing?.id === item?.id
            }">
            <!-- Edit -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                <button title="Add" *ngIf="item?.id === 'add' && !edit" pButton pRipple text rounded severity="success" type="button" pInitEditableRow
                    icon="pi pi-plus" (click)="onRowEditInit(item)"></button>
                <button title="Edit" *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                    text rounded (click)="onRowEditInit(item)"></button>
                <button title="Save" *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                    severity="success" text rounded (click)="onRowEditSave(item)"></button>
                <button title="Cancel" *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                    severity="danger" text rounded (click)="onRowEditCancel(item)"></button>
            </td>
            <!-- Status-->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                <div (click)="onStatusClick(item)">
                    <ef-status-icon [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="select-cell">
                <p-tableCheckbox [value]="rowData" *ngIf="!editing"></p-tableCheckbox>
            </td>
            <!-- Contractdesc -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="disabled">
                {{ item.Contractdesc }}
            </td>
            <!-- Chargenumber -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="disabled">
                {{ item.Chargenumber }}
            </td>
            <!-- type -->
            <td pFrozenColumn [frozen]="IsColumnFrozen" class="disabled">
                {{ item.Contracttype }}
            </td>
            <!--  ADDRESS GROUP -->
            <!-- ShowEIN -->
            <td *ngIf="displayAddress">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="ShowEIN"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.ShowEIN"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.ShowEIN,
                                green: item?.ShowEIN
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.ShowEIN,
                                green: item?.ShowEIN
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Remitaddrid -->
            <td *ngIf="displayAddress" [attr.title]="
                    (remitAddresses | itemlookup: 'value':item?.Remitaddrid)
                        ?.label
                ">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="remitAddresses" [rowData]="item" property="Remitaddrid"></ef-dropdown>
                        <!-- <p-dropdown
                            [options]="remitAddresses"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Remit To"
                            [(ngModel)]="item.Remitaddrid"
                        >
                        </p-dropdown> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        remitAddresses
                        | itemlookup: 'value':item?.Remitaddrid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (addresses | itemlookup: 'value':item?.Remitaddrid)
                        ?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Billtoaddrid -->
            <td *ngIf="displayAddress" [attr.title]="
                    (billingAddresses | itemlookup: 'value':item?.Billtoaddrid)
                        ?.label
                ">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="billingAddresses" [rowData]="item" property="Billtoaddrid"></ef-dropdown>
                        <!-- <p-dropdown
                            [options]="billingAddresses"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Bill To"
                            [(ngModel)]="item.Billtoaddrid"
                        >
                        </p-dropdown> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        billingAddresses
                        | itemlookup: 'value':item?.Billtoaddrid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (addresses | itemlookup: 'value':item?.Billtoaddrid)
                        ?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- GENERAL INVOICE INFORMATION -->
            <!--  Invoiceviewoptionid -->
            <td [attr.title]="
                    (
                        invoiceViewOptions
                        | itemlookup: 'value':item?.Invoiceviewoptionid
                    )?.label
                ">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="invoiceViewOptions" [rowData]="item"
                            property="Invoiceviewoptionid"></ef-dropdown>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        invoiceViewOptions
                        | itemlookup: 'value':item?.Invoiceviewoptionid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        invoiceViewOptions
                        | itemlookup: 'value':item?.Invoiceviewoptionid
                        )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Invprefix -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input title="Invoice Prefix" pInputText [(ngModel)]="item.Invprefix" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Invprefix }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Invprefix }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showindirectrates -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showindirectrates"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showindirectrates"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showindirectrates,
                                green: item?.Showindirectrates
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showindirectrates,
                                green: item?.Showindirectrates
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showfundingbalance -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showfundingbalance"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showfundingbalance"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showfundingbalance,
                                green: item?.Showfundingbalance
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showfundingbalance,
                                green: item?.Showfundingbalance
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showcontractbalance -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showcontractbalance"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showcontractbalance"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcontractbalance,
                                green: item?.Showcontractbalance
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcontractbalance,
                                green: item?.Showcontractbalance
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showcosttypesummary -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input [disabled]="
                                (
                                    invoiceViewOptions
                                    | itemlookup
                                        : 'value'
                                        : item?.Invoiceviewoptionid
                                )?.label.includes('(Labor Only)')
                            " *ngIf="item" type="checkbox" [(ngModel)]="item['Showcosttypesummary']" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcosttypesummary,
                                green: item?.Showcosttypesummary
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcosttypesummary,
                                green: item?.Showcosttypesummary
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showlaborrates -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showlaborrates"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showlaborrates"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showlaborrates,
                                green: item?.Showlaborrates
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showlaborrates,
                                green: item?.Showlaborrates
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showburdens -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showburdens"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showburdens"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showburdens,
                                green: item?.Showburdens
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showburdens,
                                green: item?.Showburdens
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showcurrentactivityonly -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showcurrentactivityonly"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showcurrentactivityonly"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcurrentactivityonly,
                                green: item?.Showcurrentactivityonly
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcurrentactivityonly,
                                green: item?.Showcurrentactivityonly
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Showcosttypesummaryburden -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-checkbox [rowData]="item" property="Showcosttypesummaryburden"></ef-checkbox>
                        <!-- <p-checkbox
                            binary="true"
                            [(ngModel)]="item.Showcosttypesummaryburden"
                        ></p-checkbox> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcosttypesummaryburden,
                                green: item?.Showcosttypesummaryburden
                            }"></i>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <i [ngClass]="{
                                pi: true,
                                'pi-check': item?.Showcosttypesummaryburden,
                                green: item?.Showcosttypesummaryburden
                            }"></i>
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- accountClass -->
            <td [attr.title]="item?.Accountclass">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText placeholder="Account Class" [(ngModel)]="item.Accountclass"
                            title="Account Class" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        accountClassProperties
                        | itemlookup: 'value':item?.Accountclass
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Accountclass }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- FOOTER GROUP -->
            <!-- signature -->
            <td *ngIf="displayFooter" [attr.title]="
                    (
                        signatureLineProperties
                        | itemlookup: 'value':item?.Siglineid
                    )?.label
                ">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="signatureLineProperties" [rowData]="item"
                            property="Siglineid"></ef-dropdown>
                        <!-- <p-dropdown
                            [options]="signatureLineProperties"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Signature"
                            [(ngModel)]="item.Siglineid"
                        >
                        </p-dropdown> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        signatureLineProperties
                        | itemlookup: 'value':item?.Siglineid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        signatureLineProperties
                        | itemlookup: 'value':item?.Siglineid
                        )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- disclaimer -->
            <td *ngIf="displayFooter" [attr.title]="
                    (
                        disclaimerProperties
                        | itemlookup: 'value':item?.Disclaimerid
                    )?.label
                ">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="disclaimerProperties" [rowData]="item"
                            property="Disclaimerid"></ef-dropdown>
                        <!-- <p-dropdown
                            [options]="disclaimerProperties"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Disclaimer"
                            [(ngModel)]="item.Disclaimerid"
                        >
                        </p-dropdown> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        disclaimerProperties
                        | itemlookup: 'value':item?.Disclaimerid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        disclaimerProperties
                        | itemlookup: 'value':item?.Disclaimerid
                        )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- payment terms -->
            <td *ngIf="displayFooter" [attr.title]="
                    (
                        paymentTermsProperties
                        | itemlookup: 'value':item?.Paymenttermsid
                    )?.label
                ">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <ef-dropdown [items]="paymentTermsProperties" [rowData]="item"
                            property="Paymenttermsid"></ef-dropdown>
                        <!-- <p-dropdown
                            [options]="paymentTermsProperties"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Payment Terms"
                            [(ngModel)]="item.Paymenttermsid"
                        >
                        </p-dropdown> -->
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                        (
                        paymentTermsProperties
                        | itemlookup: 'value':item?.Paymenttermsid
                        )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                        (
                        paymentTermsProperties
                        | itemlookup: 'value':item?.Paymenttermsid
                        )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
